/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const DailyClosingDetailState = Record({
  id: null,
  daily_closing_head_id: null,
  account_title_group_id: null,
  account_title_id: null,
  account_title_detail_id: null,
  price: 0,
  remarks: null
})

export { DailyClosingDetailState }
